import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialManageComponent } from './materialManage.component';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    SharedModule
  ],
  declarations: [MaterialManageComponent],
  entryComponents:[MaterialManageComponent]
})
export class MaterialManageModule { }
